import axios from "axios";
import config from '../config'

export function getUserStatsBySlug(address, slugId) {
    let url = `${config.URL}/api/lands/stats/${address}/${slugId}`;
    return axios.get(url).then((response) => {
        return response.data.data
    });
}
